module.exports = __webpack_public_path__ + "img/首页品牌崇芳.png";